<template>
  <div class="modify">
    <div class="weui-cells" style="margin-top: 0;">
      <a href="javascript:;" class="weui-cell weui-cell_access">
        <div class="weui-cell__bd">
          <p>头像</p>
        </div>
        <div class="weui-cell__ft"><img :src="accountData.avatar && accountData.avatar.length > 0 ? accountData.avatar : picUrl.defaultImage" class="avatar" id="avatar"></div>
        <input id="chooseImg" type="file" name="image"  accept="image/*"  @change="chooseImg($event)">
      </a>
      <router-link to="modifyName" class="weui-cell weui-cell_access">
        <div class="weui-cell__bd">
          <p>昵称</p>
        </div>
        <div class="weui-cell__ft">{{accountData.nickName}}</div>
      </router-link>
      <!--<router-link to="modifyMobile" class="weui-cell weui-cell_access">
        <div class="weui-cell__bd">
          <p>手机号</p>
        </div>
        <div class="weui-cell__ft">{{accountData.mobile}}</div>
      </router-link>-->
    </div>
    <div id="avatarPreview" style="display: none;"></div>
    <div class="bottom_btn"
         @click="navigateToPhone">更换绑定账户</div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'modify-index',
  data () {
    return {
      picUrl: {
        defaultImage: 'https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/cimen/share.png'
      },
      accountData: {
        avatar: '',
        nickName: ''
      }
    }
  },
  activated () {
    this.getMyAccount()
  },
  methods: {
    navigateToPhone () {
      // let locationHref = window.location.href
      // localStorage.removeItem('IS_CIMEN_STAR_USER')
      // this.$router.push({path: '/login', query: {fromurl: locationHref}})

      // 1.4.2 更换为解绑操作
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/unbinding'
        })
        .then(res => {
          if (res.success) {
            self.getMyAccount()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getMyAccount () { // 查询用户信息
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/account/total/obtain/my/account'
        })
        .then(res => {
          if (res.success) {
            self.accountData = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    chooseImg (event) { // 选择图片
      // console.log(event)
      let self = this
      let image = document.getElementById('avatarPreview'); //预览对象
      this.clip(event, self, {
        resultObj : image,
        aspectRatio : 1
      })
    },
    uploadAvatar (base64Result) {
      console.log(base64Result)
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/account/update/avatar',
          body: {
            avatar: base64Result
          }
        })
        .then(res => {
          if (res.success) {
            // 成功后刷新个人信息
            this.getMyAccount()
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped lang="less">
.modify {
  .avatar{
    width: 75px;
    height: 75px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    overflow: hidden;
  }
  #chooseImg{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}
.bottom_btn {
  position: fixed;
  bottom: 0;
  height: 90px;
  line-height: 90px;
  left: 0;
  font-size: 34px;
  width: 100%;
  background: #e9e9e9;
  color: #7d7d7d;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/mine/modify/index.vue